import { DashboardLayout } from "@/components/dashboard/layouts/DashboardLayout";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useQuery } from "react-query";
import { useState } from "react";
import { BASE_URL } from "@/dashboardQueries";
import { Flow } from "@/models/flows";
import { PaginatedResponse } from "@/models/Dashboard";
import { Table } from "@/components/Table";
import { RouteIcon } from "lucide-react";

const fetchFlows = async (page: number): Promise<PaginatedResponse<Flow>> => {
  const response = await axios.get(`${BASE_URL}/flows?page=${page}`);
  return response.data;
};

export const Flows = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const { data, isLoading, isError } = useQuery(["flows", page], () =>
    fetchFlows(page)
  ); // Replace `1` with dynamic pagination logic if needed.

  return (
    <DashboardLayout
      pageTitle="Flows"
      workInProgress="Flows are still a work in progress, and don’t reflect the
                final quality or functionality. Feedback welcome!"
      rightControls={
        <div>
          <button
            onClick={() => {
              navigate("/dashboard/flows/create");
            }}
            type="button"
            className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Create
          </button>
        </div>
      }
      requiredPermissions={[]}
    >
      <div className="overflow-x-scroll">
        <div className="w-full pb-36">
          {isLoading && <p>Loading...</p>}
          {isError && <p>Error loading flows.</p>}
          {data?.results && data.results.length > 0 ? (
            <div className="relative w-full overflow-hidden">
              <Table
                headers={["Name", ""]}
                records={data.results}
                getPageOfRecords={(page: number) => {}}
                rowRenderer={(flow: Flow) => (
                  <>
                    <td
                      // data-field-type={flow.fieldType}
                      onClick={() => {}}
                      className={`pl-8 py-3 text-sm font-medium text-gray-500 cursor-pointer min-w-[16rem]`}
                    >
                      <div className="flex items-center space-x-2 text-gray-400">
                        {flow.name}
                      </div>
                    </td>
                    <td
                      // data-field-type={flow.fieldType}
                      onClick={() => {}}
                      className={`underline pl-8 py-3 text-sm font-medium text-gray-500 cursor-pointer min-w-[16rem]`}
                    >
                      <Link
                        to={`/dashboard/flows/${flow.id}/runs`}
                        className="flex items-center space-x-2 text-gray-400"
                      >
                        <RouteIcon className="h-4 w-4 mr-2" />
                        Flow Runs
                      </Link>
                    </td>
                  </>
                )}
                pagination={data}
              />

              {/* {data.results.map((flow: Flow) => (
                <div
                  key={flow.id}
                  className="rounded-lg border border-gray-200 p-4 shadow-sm"
                >
                  <h4 className="text-lg font-semibold">{flow.name}</h4>
                  <p className="text-sm text-gray-500">{flow.description}</p>
                </div>
              ))} */}
            </div>
          ) : (
            <div className="text-center">
              <h3 className="mt-2 text-xl font-semibold text-gray-900 dark:text-white">
                No Flows yet
              </h3>
              <p className="mt-1 text-sm text-gray-500">
                You can start by creating a Flow below
              </p>
              <div className="mt-6">
                <button
                  type="button"
                  onClick={() => navigate("/dashboard/flows/create")}
                  className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                    data-slot="icon"
                    className="-ml-0.5 mr-1.5 h-5 w-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 4.5v15m7.5-7.5h-15"
                    ></path>
                  </svg>
                  Create Flow
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};
